<scoot-header></scoot-header>
<div
  class="page-content"
  [ngStyle]="{
    height: 'calc(100vh - 48px)',
    top: '48px',
  }"
>
  <ng-content select="*"></ng-content>
</div>
<app-footer></app-footer>
